import React from "react"
import { FieldArray, FormikProps } from "formik"
import { NdfGroupedBasicFields } from "./NdfGroupedBasicFields"
import { NdfGroupedMealSection } from "./NdfGroupedMealSection"
import { NdfGroupedMileageSection } from "./NdfGroupedMileageSection"
import { NdfGroupedCommentSection } from "./NdfGroupedCommentSection"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM } from "@common-constants/*"
import MyInputFormField from "@common-components/fields/MyInputFormField"

interface Props {
     helpers: FormikProps<any>
     validationSchema: any
     detailsIndemniteKm: any
     setDetailsIndemniteKm: any
     calculateDistance: (idx: number, dep?: string, arr?: string) => Promise<number>
     syncKM: (idx: number, dist: number, ar: boolean, nb: number) => void
}

export const NdfGroupedDetailsEditSection = ({ helpers, validationSchema, detailsIndemniteKm, setDetailsIndemniteKm, calculateDistance, syncKM }: Props) => {
     return (
          <div className="d-flex flex-column gap-6">
               <FieldArray name="depenses">
                    {({ push, remove }) => (
                         <div className="d-flex flex-column gap-8">
                              {helpers.values.depenses.map((item: any, index: number) => {
                                   const isKm = item.categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM
                                   const showRest = !isKm || (isKm && !!item.moisAnneeKm)

                                   return (
                                        <div className="card shadow-sm border border-gray-200" key={index}>
                                             <div className="card-header bg-light-primary bg-opacity-25 min-h-50px">
                                                  <h3 className="card-title fw-boldest text-primary fs-5">Dépense n°{index + 1}</h3>
                                                  <div className="card-toolbar">
                                                       {/* AJOUT : Bouton de suppression de la ligne */}
                                                       {helpers.values.depenses.length > 1 && (
                                                            <button className="btn btn-icon btn-sm btn-light-danger" type="button" onClick={() => remove(index)}>
                                                                 <i className="fas fa-trash fs-6"></i>
                                                            </button>
                                                       )}
                                                  </div>
                                             </div>
                                             <div className="card-body p-6">
                                                  <div className="d-flex flex-column gap-4">
                                                       <NdfGroupedBasicFields helpers={helpers} validationSchema={validationSchema} index={index} namePrefix="depenses" />

                                                       {item.categorie && (
                                                            <div>
                                                                 <div className="my-4 separator separator-dashed" />
                                                                 <NdfGroupedMealSection helpers={helpers} validationSchema={validationSchema} index={index} namePrefix="depenses" />

                                                                 {!isKm && (
                                                                      <MyInputFormField
                                                                           formikProps={helpers}
                                                                           validationSchema={validationSchema}
                                                                           name={`depenses[${index}].montantTTC`}
                                                                           label={<div className="required">Montant TTC</div>}
                                                                           type="number"
                                                                           placeholder="Montant TTC"
                                                                           classNameLabel="col-lg-4"
                                                                           classNameField="col-lg-8"
                                                                      />
                                                                 )}

                                                                 <NdfGroupedMileageSection
                                                                      helpers={helpers}
                                                                      validationSchema={validationSchema}
                                                                      index={index}
                                                                      namePrefix="depenses"
                                                                      detailsIndemniteKm={detailsIndemniteKm}
                                                                      setDetailsIndemniteKm={setDetailsIndemniteKm}
                                                                      calculateDistance={calculateDistance}
                                                                      syncKM={syncKM}
                                                                 />

                                                                 {showRest && (
                                                                      <NdfGroupedCommentSection
                                                                           helpers={helpers}
                                                                           validationSchema={validationSchema}
                                                                           index={index}
                                                                           namePrefix="depenses"
                                                                      />
                                                                 )}
                                                            </div>
                                                       )}
                                                  </div>
                                             </div>
                                        </div>
                                   )
                              })}

                              {/* AJOUT : Bouton pour ajouter une nouvelle dépense dans le groupe */}
                              <button
                                   className="btn btn-light-primary fw-boldest border border-primary border-dashed py-4"
                                   type="button"
                                   onClick={() =>
                                        push({
                                             id: undefined, // Pas d'ID pour une nouvelle ligne
                                             date: "",
                                             categorie: "",
                                             montantTTC: "",
                                             description: "",
                                             numeroTicket: "",
                                             isAllerRetour: false,
                                             joursKm: [],
                                        })
                                   }
                              >
                                   <i className="fas fa-plus-circle me-2 fs-4" /> Ajouter une autre ligne
                              </button>
                         </div>
                    )}
               </FieldArray>
          </div>
     )
}
